export default "__VITE_ASSET__CRtKAG2G__";